import React from 'react';
import { PRESETS, rangoDePreset, S } from './reportesCommon';

// Filtros globales compartidos por todas las categorias del hub de reportes.
// Responsive: se envuelven en filas multiples (flexWrap); en pantallas pequenas
// los controles fluyen sin solaparse.
export default function FiltrosGlobales({
  filtros,
  setFiltros,
  sedes,
  deptos,
  mostrarDepartamento = false,
}) {
  const aplicarPreset = (id) => {
    if (id === 'custom') {
      setFiltros((f) => ({ ...f, preset: id }));
      return;
    }
    const [a, b] = rangoDePreset(id);
    setFiltros((f) => ({ ...f, preset: id, fechaDesde: a, fechaHasta: b }));
  };

  const set = (k) => (e) => setFiltros((f) => ({ ...f, [k]: e.target.value }));

  return (
    <div
      style={{
        display: 'flex',
        gap: '8px',
        flexWrap: 'wrap',
        alignItems: 'center',
        width: '100%',
      }}
    >
      {PRESETS.map((p) => (
        <button
          key={p.id}
          onClick={() => aplicarPreset(p.id)}
          style={{ ...S.btn, ...(filtros.preset === p.id ? S.btnActive : {}) }}
        >
          {p.label}
        </button>
      ))}
      {filtros.preset === 'custom' && (
        <>
          <input
            type="date"
            value={filtros.fechaDesde}
            onChange={set('fechaDesde')}
            style={S.input}
          />
          <input
            type="date"
            value={filtros.fechaHasta}
            onChange={set('fechaHasta')}
            style={S.input}
          />
        </>
      )}
      <select value={filtros.sede} onChange={set('sede')} style={S.select}>
        <option value="">Todas las sedes</option>
        {sedes.map((s) => (
          <option key={s.codigo} value={s.codigo}>
            {s.nombre}
          </option>
        ))}
      </select>
      {mostrarDepartamento && (
        <select
          value={filtros.departamento}
          onChange={set('departamento')}
          style={S.select}
        >
          <option value="">Todas las categorías</option>
          {deptos.map((d) => (
            <option key={d.codigo} value={d.codigo}>
              {d.nombre}
            </option>
          ))}
        </select>
      )}
    </div>
  );
}
